// extracted by mini-css-extract-plugin
module.exports = {"joystickIcon":"JoystickIcon_joystickIcon__2HmCM"};